import { put, call, all, takeLatest } from 'redux-saga/effects';
import { merge, get, clone, set } from 'lodash';
import { ADMIN, ACTIONCOMMON } from '../../../actionTypes';
import { APICOMMON } from '../../../actionApi';
import { request } from '../../../utils/request';
import { API } from '../../../env';
function* getAdminList(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOMMON.AMDINLIST,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		yield put({ type: ADMIN.SET_ADMIN_LIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* addAdmin(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOMMON.ADMINADD,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		// yield put({ type: ACTIONALBUM.SET_ALBUM_LIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* deleteAdmin(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'DELETE',
		url: API.COMMON_PORXY + APICOMMON.ADMINREMOVE,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		// yield put({ type: ACTIONALBUM.SET_ALBUM_LIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
let accountSaga = [takeLatest(ADMIN.FETCH_ADMIN_LIST, getAdminList), takeLatest(ADMIN.FETCH_ADMIN_ADD, addAdmin), takeLatest(ADMIN.FETCH_ADMIN_REMOVE, deleteAdmin)];
export { accountSaga };
